import { FC } from "react"
import { TestimonialsPage as TestimonialsPageContent } from "../../../components/LandingPage/TestimonialsPage"

export const LandingTestimonialsPage: FC = () => {
  return <TestimonialsPageContent />
}
